import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page-wrapper">
      {/* Deep Blue/Black Animated Background */}
      <div className="animated-bg">
        <div className="glow-orb o1"></div>
        <div className="glow-orb o2"></div>
        <div className="grid-overlay"></div>
      </div>

      <div className="main-content-card">
        {/* Branding Section */}
        <div className="brand-header">
          <div className="car-animation-container">
             <i className="fas fa-car-side main-car-icon"></i>
             <div className="headlight-glow"></div>
          </div>
          <h1 className="main-business-name">
            BHOPAL <span className="blue-gradient-text">SEAT COVER</span>
          </h1>
          <p className="business-subtitle">PREMIUM INTERIOR & ACCESSORIES HUB</p>
        </div>

        {/* Professional Info Grid */}
        <div className="info-grid-container">
          <div className="info-box">
            <span className="info-icon"><i className="fas fa-user-check"></i></span>
            <div className="info-details">
              <label>ADMIN / OWNER</label>
              <strong>Mohammad Rashid Khan</strong>
            </div>
          </div>

          <div className="info-box">
            <span className="info-icon"><i className="fas fa-phone-alt"></i></span>
            <div className="info-details">
              <label>CONTACT NUMBER</label>
              <strong>+91 98765 43210</strong>
            </div>
          </div>

          <div className="info-box full-width-info">
            <span className="info-icon"><i className="fas fa-map-marker-alt"></i></span>
            <div className="info-details">
              <label>SHOP ADDRESS</label>
              <strong>Shop No. 12, MP Nagar Zone-II, Bhopal (M.P.)</strong>
            </div>
          </div>
        </div>

        {/* Compact Modern Buttons */}
        <div className="button-group">
          <button className="action-btn btn-filled" onClick={() => navigate('/login')}>
            <i className="fas fa-sign-in-alt"></i> LOGIN
          </button>
          <button className="action-btn btn-outline" onClick={() => navigate('/register')}>
            REGISTER <i className="fas fa-arrow-right"></i>
          </button>
        </div>

        <div className="bottom-tagline">
          <span>AUTHENTIC LEATHER</span> • <span>CUSTOM DESIGN</span> • <span>DURABLE QUALITY</span>
        </div>
      </div>

      <footer className="simple-footer">
        © 2026 BHOPAL SEAT COVER | QUALITY YOU CAN TRUST
      </footer>
    </div>
  );
};

export default LandingPage;
